<template>
  <div class="bind-phone">
    <img src="@/assets/images_member/Group 829@2x.png" class="bg-img" alt="">
    <div class="per-bind">
      <div class="bind-top">
        <img src="@/assets/images_member/image 112@2x.png" class="top-img" alt="">
        <!-- <div class="txt txt1">完成绑定可获得特惠折扣</div>
        <div class="txt txt2">10000</div>
        <div class="txt txt3">最高</div> -->
      </div>
      <div class="bind-block">
        <div class="div-input">
          <input type="text" placeholder="请输入手机号" v-model="mobile" class="input-txt">
        </div>
        <div class="div-input">
          <input type="text" placeholder="请输入验证码" v-model="mobileCode" class="input-txt">
          <div class="get-code" v-if="!isclick" @click="handleGetCode">获取验证码</div>
          <van-count-down class="get-code" :time="time" format="ss" @finish="handleFinish" v-else />
        </div>
        <div class="div-input code" v-if="hasCode">
          <div class="code-txt">
            <div class="code1" v-if="!isEdit">{{ code }}</div>
            <div class="code1" v-else>
              <input type="text" class="code-input" v-model="code">
            </div>
            <!-- <div class="code2" @click="isEdit = true">点击可修改邀请码</div> -->
          </div>
          <!-- <div class="code3">好友：{{ user_info.nickname }} {{ user_info.mobile }}</div> -->
        </div>
        <div class="div-input" v-if="!hasCode">
          <input type="text" v-model="code" placeholder="请输入推荐码/无推荐人可不填" class="input-txt">
        </div>
        <van-checkbox v-model="checked" icon-size="16px" shape="square" checked-color="#FFFFFF">
          已阅读并同意
          <div class="xieyi" @click="handleJump('SINGLEPAGE1')">《用户协议》</div>
          <!-- <div class="xieyi" @click="handleJump('SINGLEPAGE2')">、《隐私声明》</div> -->
        </van-checkbox>
        <div class="submit-btn" @click="handleSubmit" :class="isForm ? 'cur' : ''">绑定领取新人礼</div>
      </div>
      <div class="bind-foot">
        <div class="foot-item">
          <img src="@/assets/images_member/Group 831@2x.png" class="foot-item-cover" alt="">
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getCodeByMobile, bindMobile, getInvUser } from '@/api/bind'
import { Toast } from 'vant'
import store from '@/store'
export default {
  data () {
    return {
      checked: false,
      hasCode: false,
      mobile: '',
      time: 60 * 1000,
      isclick: false,
      mobileCode: '', // 验证码
      code: '', // 邀请码
      user_info: {},
      isEdit: false,
    }
  },
  computed: {
    isForm () {
      return this.mobile && this.mobileCode
    }
  },
  mounted () {
    let invCode = this.$route.query.code || localStorage.getItem('invCode')
    getInvUser({
      inv_code: invCode
    }).then(res => {
      this.user_info = res.data.user_info
      this.code = invCode
      if (res.code === 1 && res.data.length > 0) {
        this.hasCode = true
      }
    }).catch(err => {
      console.log(err)
    })
  },
  methods: {
    handleGetCode () {
      if (!this.mobile) {
        Toast('请输入手机号')
        return
      }
      let params = {
        mobile: this.mobile
      }
      this.isclick = true
      getCodeByMobile(params).then(res => {
        console.log(res)
      }).catch(err => {
        console.log(err)
      })
    },
    handleFinish () {
      this.isclick = false
    },
    handleSubmit () {
      if (!this.mobile) {
        Toast('请输入手机号')
        return
      }
      if (!this.mobileCode) {
        Toast('请输入验证码')
        return
      }
      if (!this.checked) {
        Toast('请先同意用户协议、隐私申明')
        return
      }
      let params = {
        mobile: this.mobile,
        code: this.mobileCode,
        inv_code: this.code,
      }
      bindMobile(params).then(res => {
        this.isBindPhone = true
        Toast(res.msg)
        if (res.code === 1) {
          store.dispatch('GetUsers').then(res => {
            setTimeout(() => {
              this.$router.back()
            })
          })
        }
      })
    },
    handleJump(type) {
      let url = ''
      switch (type) {
        case 'SINGLEPAGE1':
          url = '/singlePage?id=5'
          break
        case 'SINGLEPAGE2':
          url = '/singlePage?id=6'
          break

        default:
          break
      }
      let pathParams = {
        path: url,
      }
      this.$router.push(pathParams)
    }
  }
}
</script>
<style lang="less" scoped>
.bind-phone {
  width: 100vw;
  height: 100vh;
  position: relative;
  padding-top: 30px;
  box-sizing: border-box;

  .bg-img {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
  }

  .per-bind {
    position: relative;
    .bind-top {
      width: 280px;
      height: 220px;
      margin-left: 48px;
      position: relative;

      .top-img {
        width: 100%;
        height: 100%;
        display: block;
      }

      .txt {
        width: 100%;
        text-align: center;
        position: absolute;

        &.txt1 {
          top: 32px;
          line-height: 12px;
          font-size: 12px;
          color: #2F3131;
        }

        &.txt2 {
          justify-content: center;
          line-height: 40px;
          font-size: 40px;
          color: #504632;
          font-weight: 600;
          top: 60px;
          display: flex;
          align-items: baseline;
          &::before {
            color: #504632;
            font-size: 20px;
            content: "￥";
          }
        }
        &.txt3 {
          font-size: 12px;
          color: #C9B592;
          text-align: center;
          top: 105px;
        }
      }

    }
    .bind-block {
      background-color: #2F3131;
      margin: 0 14px;
      margin-top: -16px;
      border-radius: 10px;
      position: relative;
      padding: 0 14px;
      box-sizing: border-box;
      margin-bottom: 14px;
      padding-bottom: 20px;
    }
  }

  .div-input {
    line-height: 60px;
    display: flex;
    border-bottom: 1px solid #666666;
    align-items: center;

    &.code {
      display: block;
      padding-top: 30px;
      padding-bottom: 20px;
      box-sizing: border-box;

      .code-txt {
        display: flex;
        align-items: center;
        line-height: 16px;

        .code1 {
          font-size: 16px;
          width: 72px;
          color: #FFFFFF;

          .code-input {
            background-color: transparent;
            outline: none;
            border: none;
            width: 72px;
          }
        }

        .code2 {
          font-size: 16px;
          color: #999999;
        }
      }

      .code3 {
        font-size: 12px;
        color: #FFFFFF;
        line-height: 12px;
        margin-top: 10px;
      }
    }

    .input-txt {
      font-size: 16px;
      outline: none;
      border: none;
      background-color: transparent;
      flex: 1;
      color: #fff;

      &::placeholder {
        font-size: #999999;
      }
    }

    .get-code {
      color: #504632;
      font-size: 14px;
      text-align: center;
      line-height: 38px;
      font-weight: 500;
      width: 102px;
      border-radius: 100px;
      background-color: #F0E1C0;
      height: 38px;
    }
  }

  /deep/ .van-checkbox {
    margin-top: 20px;

    .van-checkbox__icon--checked {
      .van-icon {
        color: #181919;
      }
    }

    .van-checkbox__label {
      display: flex;
      color: #626366;
      font-size: 12px;

      .xieyi {
        color: #fff;
      }
    }
  }

  .submit-btn {
    margin-top: 18PX;
    width: 100%;
    height: 48px;
    line-height: 48px;
    text-align: center;
    background-color: #6C685E;
    border-radius: 100px;
    font-size: 16px;
    color: #504632;
    font-weight: 600;

    &.cur {
      background-color: #F0E1C0;
    }
  }

  .bind-foot {
    padding: 0 14px;

    .foot-item-cover {
      width: 100%;
      height: 146px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/bindPhone.vue